import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { LandingPage } from "@pages";
import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="*"
          element={
            <Layout className="site-layout">
              <Content className="site-layout-background">
                <LandingPage />
              </Content>
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
